import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { DeveloperEffects } from './effects/developer.effects';
import { DeveloperService } from './service/developer.service';

@NgModule({
  imports: [
    EffectsModule.forFeature([DeveloperEffects])
  ],
  providers: [DeveloperService]
})
export class DeveloperModeModule {}
